// src/components/PracticeButton.js
import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PracticeButton = ({ to, label }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="h-100"
    >
      <Button
        as={Link}
        to={to}
        size="lg"
        variant="light"
        className="w-100 text-start d-flex align-items-center gap-3 p-4 rounded-4 border-0 shadow-lg"
        style={{
          transition: "all 0.3s ease-in-out",
          background: "linear-gradient(145deg, #fdd835, #fff176)",
          color: "#333",
          fontWeight: "600",
          fontSize: "1.1rem",
          boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        }}
      >
        <span>{label}</span>
      </Button>
    </motion.div>
  );
};

export default PracticeButton;
